var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConcentrateCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.822 0H26.1774C11.7418 0 0 8.26133 0 18.4145V181.586C0 191.739 11.7418 200 26.1779 200H173.822C188.258 200 200 191.739 200 181.586V18.4145C199.999 8.26133 188.258 0 173.822 0ZM188.365 181.586C188.365 187.237 181.852 191.818 173.821 191.818H26.1774C18.1473 191.818 11.6341 187.237 11.6341 181.586V18.4145C11.6341 12.7637 18.1473 8.18281 26.1774 8.18281H173.821C181.852 8.18281 188.365 12.7637 188.365 18.4145V181.586Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2695 137.086H26.1774V151.917H47.2695V137.086Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4537 137.086H68.3616V151.917H89.4537V137.086Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.637 137.086H110.546V151.917H131.637V137.086Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.822 137.086H152.73V151.917H173.822V137.086Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2695 107.417H26.1774V122.252H47.2695V107.417Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4537 107.417H68.3616V122.252H89.4537V107.417Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.637 107.417H110.546V122.252H131.637V107.417Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.822 107.417H152.73V122.252H173.822V107.417Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3616 122.252H47.2695V137.086H68.3616V122.252Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M110.546 122.252H89.4537V137.086H110.546V122.252Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.73 122.252H131.638V137.086H152.73V122.252Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3616 151.917H47.2695V166.752H68.3616V151.917Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.546 151.917H89.4537V166.752H110.546V151.917Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.73 151.917H131.638V166.752H152.73V151.917Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2695 166.752H26.1774V181.586H47.2695V166.752Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4537 166.752H68.3616V181.586H89.4537V166.752Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.637 166.752H110.546V181.586H131.637V166.752Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M173.822 166.752H152.73V181.586H173.822V166.752Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2695 77.7488H26.1774V92.5832H47.2695V77.7488Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4537 77.7488H68.3616V92.5832H89.4537V77.7488Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M131.637 77.7488H110.546V92.5832H131.637V77.7488Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M173.822 77.7488H152.73V92.5832H173.822V77.7488Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3616 92.5832H47.2695V107.417H68.3616V92.5832Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.546 92.5832H89.4537V107.417H110.546V92.5832Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M152.73 92.5832H131.638V107.417H152.73V92.5832Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2695 48.0832H26.1774V62.9145H47.2695V48.0832Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4537 48.0832H68.3616V62.9145H89.4537V48.0832Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M131.637 48.0832H110.546V62.9145H131.637V48.0832Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M173.822 48.0832H152.73V62.9145H173.822V48.0832Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3616 62.9145H47.2695V77.7488H68.3616V62.9145Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M110.546 62.9145H89.4537V77.7488H110.546V62.9145Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M152.73 62.9145H131.638V77.7488H152.73V62.9145Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2695 18.4145H26.1774V33.2488H47.2695V18.4145Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4537 18.4145H68.3616V33.2488H89.4537V18.4145Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M131.637 18.4145H110.546V33.2488H131.637V18.4145Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M173.822 18.4145H152.73V33.2488H173.822V18.4145Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3616 33.2488H47.2695V48.0832H68.3616V33.2488Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M110.546 33.2488H89.4537V48.0832H110.546V33.2488Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.73 33.2488H131.638V48.0832H152.73V33.2488Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcentrateCard);
export default __webpack_public_path__ + "static/media/concentrate-card.9afecb96a0c68950fa6578ce3cf08d87.svg";
export { ForwardRef as ReactComponent };